angular.module('app.directives.schedule').directive('broadcastTeamColorPicker', () => {
  return {
    restrict: 'E',
    scope: { vm: '=', team: '@', label: '@' },
    template: require('./broadcast-team-color-picker.html'),
    controller: function ($scope, $rootScope) {
      'ngInject';
      const { account } = $rootScope;
      $scope.colors = account.extra_features.scoreboard_spectrum
        ? SPECTRUM_COLOR_PALETTE
        : STANDARD_COLOR_PALETTE;
      $scope.select = (color) => {
        $scope.vm.service.broadcast.scoreboard_configuration[$scope.team + '_team_logo'] = color;
      };
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/broadcast-team-color-picker.js